import React from 'react';
import useScopedTranslation from 'hooks/useScopedTranslation';
import { createMessagesI18n } from './i18n';

export default function ViewCreateMessagesModal({
  Modal,
  SvgIcon,
  show,
  onClose,
  template = null, // { name, channel, content, previewContent? }
}) {
  const { t } = useScopedTranslation(createMessagesI18n);

  if (!Modal) return null;
  if (!show) return null;

  const channel = template?.channel || template?.messageType || '';
  const lowerChannel = (channel || '').toString().toLowerCase();

  const channelLabel =
    lowerChannel === 'whatsapp'
      ? 'WhatsApp'
      : lowerChannel === 'sms'
        ? 'SMS'
        : lowerChannel === 'email'
          ? 'Email'
          : channel || '';

  // Map the channel to correct SVG icon names from your DS
  const iconName =
    lowerChannel === 'whatsapp'
      ? 'whatsapp'
      : lowerChannel === 'sms'
        ? 'phone'
        : lowerChannel === 'email'
          ? 'envelope'
          : 'message';

  const previewContent = template?.previewContent || template?.content || '';

  const title = template?.name
    ? t('cm_preview_title', { name: template.name })
    : t('cm_preview_titleFallback');

  return (
    <Modal
      title={title}
      show={show}
      onClose={onClose}
      primaryBtnTxt={t('cm_preview_close')}
      primaryBtnAction={onClose}
      secondaryBtnTxt=''
      secondaryBtnAction={onClose}
      width={800}
      height='70vh'
    >
      <div className='d-flex flex-column gap-3'>
        {/* Tipo de mensaje */}
        <div className='d-flex align-items-center gap-2'>
          <div>
            {SvgIcon && (
              <SvgIcon
                name={iconName}
                size='20px'
                stroke={
                  lowerChannel === 'whatsapp'
                    ? 'var(--success-500)'
                    : lowerChannel === 'sms'
                      ? 'var(--warning-500)'
                      : lowerChannel === 'email'
                        ? 'var(--primary-500)'
                        : 'currentColor'
                }
              />
            )}
          </div>
          <span className='caption font-light'>{channelLabel}</span>
        </div>

        {/* Contenido del mensaje */}
        <div>
          <textarea
            className='form-control'
            style={{
              minHeight: '220px',
              resize: 'none',
            }}
            readOnly
            value={previewContent}
          />
        </div>

        {/* Nota / disclaimer */}
        <div className='ds-alert p-2 mb-0'>
          <p className='mini mb-0'>
            <span className='fw-semibold'>{t('cm_preview_note')}</span>
            {t('cm_preview_noteText')}
          </p>
        </div>
      </div>
    </Modal>
  );
}
